// ============================================================
// Мок-данные ТОЛЬКО для браузерного dev-превью (/cef/_f2.html).
// В игре window.mp определён → функция выходит сразу, ничего не трогает.
// Цель: вкладки выглядят «живыми» без игрового сервера.
// ============================================================
export const installDevMocks = () => {
    if (typeof window === 'undefined' || window.mp !== undefined) return;

    // --- заглушки игровых функций, без которых легаси-вкладки падают ---
    window.notificationAdd = window.notificationAdd || (() => {});
    window.getItemToCount = window.getItemToCount || (() => 2);
    window.loaderData = window.loaderData || { delay: () => true };

    // --- персонаж (поля ровно те, что читают вкладки) ---
    try {
        window.charStore.charData(JSON.stringify({
            UUID: 1, Login: 'jr_player', Name: 'Robert Green',
            Gender: true, LVL: 14, EXP: 23, Warns: 1,
            Money: 1264500, Bank: 30441, BankMoney: 18230000,
            WeddingName: 'Нет', Sim: 555123, WorkID: 7,
            FractionID: 0, FractionLVL: 0, OrganizationID: 0, OrganizationLVL: 0,
            VipLvl: 2, VipDate: '2026-07-15T00:00:00',
            CreateDate: '2026-03-02T14:21:00',
            TodayTime: 154, MonthTime: 4180, TotalTime: 19340,
            Licenses: [1, 1, 0, 1, 0, 0, 1, 1, 0],
            jobSkillsInfo: [
                { name: 'Дальнобойщик', currentLevel: 3, current: 420, nextLevel: 700 },
                { name: 'Таксист', currentLevel: 1, current: 120, nextLevel: 500 },
                { name: 'Автомеханик', currentLevel: 2, current: 60, nextLevel: 100 },
                { name: 'Инкассатор', currentLevel: 0, current: 300, nextLevel: 1000 },
                { name: 'Электрик', currentLevel: 4, current: 880, nextLevel: 1000 },
                { name: 'Почтальон', currentLevel: 1, current: 40, nextLevel: 1000 },
            ],
            houseId: 73, houseCash: '12 400$', houseCopiesHour: '250$', houseType: 2, maxcars: 3,
            BizId: 112, BizCash: '356 000$', BizCopiesHour: '1 200$',
        }));
    } catch (e) { console.warn('[devmock] charData', e); }

    try { window.accountStore.accountRedbucks(125000); } catch (e) {}

    // --- транспорт: [[id, model, plate], ...] ---
    try {
        window.gta5devmenucars(JSON.stringify([
            [1, 'sultanrs', 'JR 001'], [2, 'elegy', 'LS 777'], [3, 'dominator', 'GRN 14'],
            [4, 'comet2', 'VVS 21'], [5, 'baller', 'JST 55'], [6, 'bati', 'MTO 09'],
        ]));
    } catch (e) { console.warn('[devmock] cars', e); }

    // --- квесты (каталог локальный, нужен только прогресс) ---
    try {
        window.questStore.init(JSON.stringify([
            { ActorName: 'npc_zdobich', Line: 0, Stage: 0 },
            { ActorName: 'npc_kachalka', Line: 0, Stage: 0 },
            { ActorName: 'npc_oressale', Line: 0, Stage: 0 },
            { ActorName: 'npc_skindiver', Line: 0, Stage: 0 },
        ]));
    } catch (e) { console.warn('[devmock] quests', e); }

    // --- обращения ---
    try {
        window.reportsStore.addReport(3, 'Mike_Ross', 'Застрял в текстурах на стройке, вытащите пожалуйста');
        window.reportsStore.addReport(2, 'Eva_Long', 'Не выдалась награда за квест «Танцуй»');
        window.reportsStore.addReport(1, 'Tom_Hardy', 'Вопрос по летнему пропуску');
        window.reportsStore.setStatus(2, 'Robert');
    } catch (e) { console.warn('[devmock] reports', e); }

    // --- хранилище (склад донат-предметов) ---
    try {
        window.gta5devmenustockitems([
            { SqlId: 1, ItemId: 1, Count: 2, Index: 0 },
            { SqlId: 2, ItemId: 2, Count: 1, Index: 1 },
            { SqlId: 3, ItemId: 5, Count: 4, Index: 2 },
            { SqlId: 4, ItemId: 8, Count: 1, Index: 3 },
        ]);
    } catch (e) { console.warn('[devmock] stock', e); }

    console.info('[devmock] браузерные мок-данные F2 установлены');
};
